'use strict';

import { constants } from './config';
const uuidV1 = require('uuid/v1');

export const DEFAULT_WOOTAG_COLOR = '#33B0E8';

export function mobileCheck() {
  var check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  return check;
}

export function tabletCheck() {
  return /(tablet|ipad|playbook|silk)|(android(?!.*mobile))/i.test(navigator.userAgent||navigator.vendor||window.opera)
}

export function isFacebookApp() {
  var ua = navigator.userAgent || navigator.vendor || window.opera;
  return (ua.indexOf("FBAN") > -1) || (ua.indexOf("FBAV") > -1);
}

export function isFacebookAd() {
  let urlParams = getUrlParams(window.location.href);

  if (urlParams.fbAd === '1') return true;
  else return false;
}

export function getMinHeight() {
  let width = window.innerWidth;
  let height = window.innerHeight;
  let videoHeight = 56.26/100 * width;
  let minHeight = 236 + videoHeight;
  return minHeight;
}

export function getOrientation() {
  let width = window.innerWidth;
  let height = window.innerHeight;
  let minHeight = getMinHeight();

  if (isFacebookAd()) return constants.ORIENTATION_PORTRAIT;
  else if (width > height || (width < height && height < minHeight)) return constants.ORIENTATION_LANDSCAPE;
  else return constants.ORIENTATION_PORTRAIT;
}

function checkStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response;
  } else {
    var error = new Error(response.statusText);
    error.response = response;
    throw error;
  }
}

export function parseJSON(response) {
  try {
    response = response.json()
  } catch(e) {}

  return response
}

export function request(url, options) {
  let ops = Object.assign({}, {
              method: 'GET',
              mode: 'cors',
              cache: 'default' }, options);

  return fetch(url, ops)
          .then(checkStatus)
          .then(parseJSON)
          .catch(e => {
            // console.log('fetch encountered an error', e)
          })
}

export function loadJS(fileURL, parent) {
  return new Promise(function(resolve, reject) {
    var jsFileElement = document.createElement("script");
    jsFileElement.type = "application/javascript";
    jsFileElement.src = fileURL;

    jsFileElement.onreadystatechange = function () {
      if (this.readyState === 'complete') {
        resolve();
      }
    }

    jsFileElement.onload = function () {
      resolve();
    }

    parent.appendChild(jsFileElement);
  });
}

export function loadCSS(fileURL, parent) {
  return new Promise((resolve, reject) => {
    var fileref = document.createElement("link");
    fileref.rel = "stylesheet";
    fileref.type = "text/css";
    fileref.href = fileURL;

    fileref.onreadystatechange = function () {
      if (this.readyState === 'complete') {
        resolve();
      }
    }

    fileref.onload = function () {
      resolve();
    }

    parent.appendChild(fileref);
  });
}

export function getCSSPath(target, release_version) {
  let domain = target.split('.com')[0] + '.com';
  let protocol = domain.split('//')[0] + '//';

  const v = release_version || new Date().getTime();

  if (window.location.href.indexOf('localhost') !== -1) {
    return '';
  }

  if (!!domain && domain.indexOf('wootag.com') !== -1) {
    return `${domain}/player/v3/style.css?v=${v}`
  }

  return `https://stagingwt.wootag.com/player/v3/style.css?v=${v}`
}

export function getDomainForAdUnit(target) {
  let domain = target.split('.com')[0] + '.com'
  let protocol = domain.split('//')[0] + '//'

  if (domain === 'https://ads.wootag.com' || domain === 'http://ads.wootag.com' || domain.includes('cdn.wootag.com')) {
      return `${protocol}www.wootag.com`
  } else if (!!domain && domain.indexOf('wootag.com') !== -1) {
      return domain
  } else {
      return `${protocol}stagingwt.wootag.com`
  }
}

export function getUrlParams(url) {
  var keyValue, params = {};

  try {
    var queryString = url.split("?")[1];
    var keyValuePairs = queryString.split("&");

    keyValuePairs.forEach(function(pair) {
      keyValue = pair.split("=");
      params[keyValue[0]] = decodeURIComponent(keyValue[1]).replace("+", " ");
    });
  } catch(e) {}

  return params
}

export function parseJsonToFormData(obj) {
  var str = [];
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) {
      str.push(encodeURIComponent(key) + "=" + encodeURIComponent(obj[key]))
    }
  }

  return str.join("&");
}

export function getScreenDimensions() {
  try {
    let parent = window.parent && window.parent.document && (window.parent.document.body || window.parent.document.documentElement);
    if (parent) {
      return `${parent.clientWidth}x${parent.clientHeight}`;
    } else {
      return `${window.innerWidth}x${window.innerHeight}`;
    }
  } catch(e) {
    return null;
  }
}

export function getReadableTime(value) {
  let hours = Math.floor(value/3600);
  let mins_remaining = value - (hours * 3600);
  let mins = Math.floor(mins_remaining/60);
  let seconds = Math.floor(mins_remaining - (mins * 60));

  if (isNaN(value)) {
    return '00:00';
  }

  if (hours < 1) {
    return pad(mins, '0', 2) + ':' + pad(seconds, '0', 2);
  } else {
    return pad(hours, '0', 2) + ':' + pad(mins, '0', 2) + ':' + pad(seconds, '0', 2);
  }
}

export function pad(string, pad, length) {
  let time = (new Array(length+1).join(pad)+string).slice(-length)
  if (isNaN(time)) {
    return '00'
  } else return time
}

export function getVideoURL(url, sizes) {

  if (typeof sizes === 'number') {
    return url;
  }

  if (url) {
    let lastIndexOfSlash = url.lastIndexOf('/');
    let lastIndexOfExtn = url.lastIndexOf('.');
    let extn = url.substr(lastIndexOfExtn);
    let newURL = url.substr(0, lastIndexOfSlash);

    if (window.innerWidth > 480) {
      return `${newURL}/${sizes[0]}${extn}`;
    } else if (window.innerWidth > 360) {
      if (typeof sizes[1] !== 'undefined') {
        return `${newURL}/${sizes[1]}${extn}`;
      } else {
        return `${newURL}/${sizes[0]}${extn}`;
      }
    } else {
      if (typeof sizes[2] !== 'undefined') {
        return `${newURL}/${sizes[2]}${extn}`;
      } else if (typeof sizes[1] !== 'undefined') {
        return `${newURL}/${sizes[1]}${extn}`;
      } else {
        return `${newURL}/${sizes[0]}${extn}`;
      }
    }
  } else return url;
}

export function getGUID() {
  return uuidV1();
}

export function getMedium() {
  let referrer = document.referrer
  let isFacebook = isFacebookApp()
  let medium
  // let referrerDomain = referrer.match(/:\/\/(.[^/]+)/)[1];

  if (isFacebook) {
    medium = 'Facebook'
  } else if (referrer === "") {
    medium = `Embed - ${window.location.host}`
  } else {
    medium = `Embed - ${referrer}`
  }

  return medium
}

export function createSelectionArrayFromObject(inputArr, defaultSelection) {
  var arr = [];

  inputArr && inputArr.forEach((item, index) => {
    let tempObj = {}
    tempObj.id = index + 1
    tempObj.name = item
    tempObj.enabled = true

    arr.push(tempObj);
  })

  arr.unshift({
    id: 0,
    name: defaultSelection,
    enabled: true
  })

  return arr;
}

export function isObject(item) {
  return (item && typeof item === 'object' && !Array.isArray(item));
}

export function mergeDeep(target, source) {
  let output = Object.assign({}, target);
  if (isObject(target) && isObject(source)) {
    Object.keys(source).forEach(key => {
      if (isObject(source[key])) {
        if (!(key in target))
          Object.assign(output, { [key]: source[key] });
        else
          output[key] = mergeDeep(target[key], source[key]);
      } else {
        Object.assign(output, { [key]: source[key] });
      }
    });
  }
  return output;
}

export function extendTag(tags, sourcetag) {
  let target = findTag(tags, sourcetag.src_tag_id);

  if (target) {
    sourcetag = mergeDeep(target, sourcetag);

    if (sourcetag.details.engagements && sourcetag.details.engagements.length > 0) {
      sourcetag.details.engagements[0] = mergeDeep(target.details.engagements[0], sourcetag.details.engagements[0]);
    }

    if (target.src_tag_id) {
      sourcetag.src_tag_id = target.src_tag_id;
      sourcetag = extendTag(tags, sourcetag);
    }
  }

  return sourcetag;
}

export function findTag(tags, tagId) {
  var selIndex;
  var selChild;

  tags.some((tag, idx) => {
    if (tag.id === tagId) {
      selIndex = idx;
      selChild = undefined;
      return true;
    }

    if (tag.child_tags) {
      let result = tag.child_tags.findIndex(child => child.id === tagId);
      if (result >= 0) {
        selIndex = idx;
        selChild = result;
        return true;
      }
    }
  });

  if (typeof selIndex !== 'undefined') {
    if (typeof selChild !== 'undefined') {
      return tags[selIndex].child_tags[selChild];
    } else {
      return tags[selIndex];
    }
  }
}

export function filterObjJson(obj){
  for (let key in obj) {
    if (obj.hasOwnProperty(key)) {
      if (!obj[key]) {
        delete obj[key];
      }
    }
  }
  return obj;
}

export function getMobileOS() {
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Windows Phone must come first because its UA also contains "Android"
    // if (/windows phone/i.test(userAgent)) {
    //     return "Windows Phone";
    // }

    if (/android/i.test(userAgent)) {
      return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return "iOS";
    }

    return "unknown";
}

export function getTagPreviewImage(tag, size, ignorePreviewImage) {
  let subcategory = tag && tag.settings && tag.settings.subcategory && tag.settings.subcategory[0];
  switch(tag.settings.category) {
    case 1:
    case 7:
    case 8:
    case 10:
    case 11:
    case 12:
    case 15:
    case 16:
    case 18:
    case 19:
    case 20:
      let image = getLinkedTagImage(tag.media, tag.media && tag.media.defaultImage, size, ignorePreviewImage);
      return image;
    case 9:
      switch (subcategory && subcategory.type) {
          case 900:
            let engagement = tag.details && tag.details.engagements && tag.details.engagements[0];
            let answers = engagement && engagement.answer;
            if (engagement && engagement.imagepoll) {
              return answers && answers[0] && answers[0].image
            } else {
              let image = getLinkedTagImage(tag.media, tag.media && tag.media.defaultImage, size, ignorePreviewImage);
              return image;
            }
          case 901:
          case 902:
          case 904:
          case 905:
          case 906:
          case 907:
            let image = getLinkedTagImage(tag.media, tag.media && tag.media.defaultImage, size, ignorePreviewImage);
            return image;
      }
    case 14:
      switch (subcategory && subcategory.type) {
        case 1402:
          let image = getLinkedTagImage(tag.media, tag.media.defaultImage, size, ignorePreviewImage);
          return image;
        case 1401:
        case 1403:
          let engagement = tag.details && tag.details.engagements && tag.details.engagements[0];
          let defaultImg = engagement && engagement.meta && engagement.meta.filter(item => item.default);

          if (defaultImg && defaultImg.length > 0) {
            let img = defaultImg[0];
            return img.cover_image_selected || img.url;
          } else {
            let firstGallaryElem = engagement && engagement.meta && engagement.meta[0];
            if (firstGallaryElem) {
              return firstGallaryElem.cover_image_selected || firstGallaryElem.url;
            }
          }
      }
    case 21:
      switch (subcategory && subcategory.type) {
        case 2101:
        case 2102:
        case 2103: {
          let image = getLinkedTagImage(tag.media, tag.media && tag.media.defaultImage, size, ignorePreviewImage);
          return image;
        }
        case 2104: {
          let engagement = tag.details && tag.details.engagements && tag.details.engagements[0];
          let answers = engagement && engagement.answer;
          if (engagement && engagement.imagepoll) {
            return answers && answers[0] && answers[0].image
          } else {
            let image = getLinkedTagImage(tag.media, tag.media && tag.media.defaultImage, size, ignorePreviewImage);
            return image;
          }
        }
      }
  }
}

export function updateQueryStringParameter(uri, key, value) {
  var re = new RegExp("([?&])" + key + "=.*?(&|#|$)", "i");
  if (uri.match(re)) {
    return uri.replace(re, '$1' + key + "=" + value + '$2');
  } else {
    var hash =  '';
    if( uri.indexOf('#') !== -1 ){
        hash = uri.replace(/.*#/, '#');
        uri = uri.replace(/#.*/, '');
    }
    var separator = uri.indexOf('?') !== -1 ? "&" : "?";
    return uri + separator + key + "=" + value + hash;
  }
}

export function debounce(func, wait, immediate) {
	var timeout;
	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};

export function filterTagsForDecisions(proptags) {
  let tags = proptags && JSON.parse(JSON.stringify(proptags));
  let decisionPoints = tags && tags.filter(item => item.settings.category === 15);

  if (decisionPoints && decisionPoints.length) {
    let connectedTags = [].concat(...decisionPoints.map(dp =>
                                        dp.details.engagements[0] &&
                                        dp.details.engagements[0].meta &&
                                        dp.details.engagements[0].meta.map(metaItem => metaItem.tag)));

    for (var i = tags.length - 1; i >= 0; i--) {
      let index = connectedTags.indexOf(tags[i].id);
      index !== -1 && tags.splice(i, 1);
    }
  }

  return tags;
}

export function trimLastSlash(target) {
  if (target.substr(-1) === '/') {
      return target.slice(0, -1)
  } else return target
}

export function launchExternalLink(domain, videoId, tagId) {
  domain = domain.substr(-1) === '/' ? `${domain}videos/share` : `${domain}/videos/share`;
  let url = `${domain}/${videoId}?tagid=${tagId}&ottOnly=1`;
  window.open(url, '_blank');
}

export function getLinkedTagImage(media, defaultImage, size, ignorePreviewImage, ignoreOrientation) {
  let previewImages = media && media.previewImages || {};
  const imgSrc = Object.keys(previewImages).find(key => key.includes('_src'));
  if (imgSrc && !ignorePreviewImage) {
    return getMediaPreviewImage(previewImages, size);
  }

  let images = media && media.images || {};
  images = images || {};
  let imageKeys = Object.keys(images);
  let availableRes = imageKeys.filter(item => parseInt(item.split('_')[0].substr(-1)) === 1);
  let imageResolutions = sortNumericKeys(availableRes.map(item => item.split('_')[1]));

  let targetRes = size ? size : getTargetImageRes(imageResolutions, ignoreOrientation);
  let image = defaultImage ? defaultImage : 'img1';
  return images[`${image}_${targetRes}`] || images[`${image}_src`];
}

export function getMediaPreviewImage(previewImages = {}, size) {
  const imgSrc = Object.keys(previewImages).find(key => key.includes('_src'));
  const imgName = imgSrc && imgSrc.split('_')[0];
  let targetRes = size ? size : 'src';
  const previewImg = imgName && (previewImages[`${imgName}_${targetRes}`] || previewImages[`${imgName}_src`]);
  if (previewImg) {
    return previewImg;
  }
}

export function getTargetImageRes(imageResolutions, ignoreOrientation) {
  let orientation = getOrientation();
  let viewportWidth = (orientation === constants.ORIENTATION_PORTRAIT || ignoreOrientation) ? window.innerWidth : window.innerWidth/2;
  const resClone = imageResolutions.filter(t => t !== 'src');

  let targetRes;
  const resFound = resClone.some(res => {
    targetRes = res;
    return res > viewportWidth;
  });
  return resFound ? targetRes : 'src';
}

export function sortNumericKeys(arr) {
  var sortedArr = arr.sort((a,b) => {
    a = parseInt(a);
    b = parseInt(b);
    return a-b;
  });
  const shiftedNonNumbersToEndArr = [ ...sortedArr ];
  // console.log('>>>>>>', { shiftedNonNumbersToEndArr, firt: shiftedNonNumbersToEndArr[3], sortedArr, test: [ ...sortedArr ] })
  sortedArr.forEach((item, idx) => {
    if (isNaN(item / 1)) {
      shiftedNonNumbersToEndArr.push(shiftedNonNumbersToEndArr.splice(idx, 1)[0]);
    }
  });
  // console.log({ arr, sortedArr, shiftedNonNumbersToEndArr })
  return shiftedNonNumbersToEndArr;
}

export function isMiniature() {
  return window.innerHeight < 300;
}

export function isSkipEnabled(tag, creativeData) {
  // for out-video tags if tag.details.skip = true; on clicking the tagPreview it will directly
  // open the url in blank window instead of showing tag Details---

  if (tag) {
    let category = tag.settings && tag.settings.category;
    let subcategory = tag.settings && tag.settings.subcategory && tag.settings.subcategory[0];
    let type = subcategory && subcategory.type;
    let isOutVideo = false;

    if (!category) return false;

    switch(category) {
      case 1:
      case 7:
      case 8:
      case 10:
      case 18:
        isOutVideo = true;
        break;
      default:
        isOutVideo = false;
        break;
    }

    if (type === 1803) {
      isOutVideo = false;
    }

    if (isOutVideo && tag && tag.details && tag.details.skip) {
      // handle out-video tags
      let engagement = subcategory.engagements[0];
      let url = engagement && engagement[`value|${engagement.slug}`];

      if (category === 10) {
        let playStoreLink = engagement && engagement[`linkplaystore|${engagement.slug}`];
        let appStoreLink = engagement && engagement[`linkappstore|${engagement.slug}`];
        let deviceType = getMobileOS();

        if (deviceType === 'Android' && playStoreLink) url = playStoreLink;
        else if (deviceType === 'iOS' && appStoreLink) url = appStoreLink;
      }

      if (!/^(http|https):\/\//.test(url)) {
        url = `http://${url}`;
      }

      handleExternalLinksViaClickThru(url, creativeData);
      return true;
    }

    return false;
  }
}

export function filterAgeGate(json) {
  const tagsWithoutGates = [];
  const gates = [];
  json.tags.forEach(item => {
    const settings = item && item.settings;
    const subcategory = settings.subcategory && settings.subcategory[0] && settings.subcategory[0].type;


    // setting default merchant for commerce thirdpartyapi tags---
    if (item.settings.category === 1 && item.details && item.details.thirdPartyApi && item.details.skuSet && item.details.skuSet.length && !item.details.merchant) {
      item = updateTagProductPrice(item.details.skuSet[0], item);
    }

    if (subcategory && subcategory === 903) {
    gates.push(item);
    } else {
    tagsWithoutGates.push(item);
    }
  });
  json.tags = tagsWithoutGates;

  json.gates = gates;
  json.otags = json.tags;

  return json;
}

export function updateTagProductPrice(selectedMerchant, tag) {
  const price = selectedMerchant.offerPrice;
  // const currency = selectedMerchant.currency || '₱';
  // const endUrlId = selectedMerchant.productId;
  // const productLink = `https://api-ph.shortlyst.com/v1/products/${endUrlId}/redirect?apikey=HYx5IJslKjqja3wDcLUzVjyQAOY9amJL`;
  const productLink = selectedMerchant.merchantUrl;
  const slug = tag && tag.settings && tag.settings.subcategory && tag.settings.subcategory[0].engagements[0].slug;
  const updateSettingsEngagments = { [`value|${slug}`]: productLink };

  const settings = { ...tag.settings, subcategory: [{ ...tag.settings.subcategory[0], engagements: [{ ...tag.settings.subcategory[0].engagements[0], ...updateSettingsEngagments }] }] };

  const updatedTag = {
    ...tag,
    details: { ...tag.details, price, merchant: selectedMerchant },
    settings,
  };
  return updatedTag;
}

export function getImageLightness(imageSrc, callback) {
  var img = new Image;
  var colorSum = 0;

  img.crossOrigin = "Anonymous";

  img.onload = function() {
    var canvas = document.createElement("canvas");

    canvas.width = this.width;
    canvas.height = this.height;

    var ctx = canvas.getContext("2d");
    ctx.drawImage(this,0,0);

    var imageData = ctx.getImageData(0,0,canvas.width,canvas.height);
    var data = imageData.data;
    var r,g,b,avg;

    for(var x = 0, len = data.length; x < len; x+=4) {
      r = data[x];
      g = data[x+1];
      b = data[x+2];

      avg = Math.floor((r+g+b)/3);
      colorSum += avg;
    }

    var brightness = Math.floor(colorSum / (this.width*this.height));
    callback(brightness);
  }

  img.src = imageSrc;
}

export function isSkinTemplate(json) {
  const meta = json && json.meta;
  const custom = json && json.custom;
  const customSkinData = custom && custom.customskin;
  const customSkinEnabled = customSkinData && customSkinData.enableSkin;
  return customSkinEnabled || (meta && meta.skins);
}

export function isMultiStoresMapRequired(tags) {
  const multiStoresWithLocation = tags.filter((tag) => {
    const settings = tag && tag.settings;
    const isMultiStore = settings && settings.subcategory && settings.subcategory[0] && settings.subcategory[0].type && settings.subcategory[0].type === 104;
    if (isMultiStore) {
      const stores = tag && tag.details && tag.details.attributes || [];
      const hasLocation = stores.some(store => store && store.details && store.details.location);
      if (hasLocation) {
        return true;
      }
    }
    return false;
  });
  return multiStoresWithLocation.length > 0; // tags with atleast one store location enabled---
}

export const sortCollectionsMedia = (products) => {
  return products.map(prod => {
    const media = prod && prod.media;

    if (Array.isArray(media)) {
      let images = {};
      media.forEach(m => images = { ...images, ...m });
      prod.media = { images };
    }
    return prod;
  });
}

export const isCollectionsTag = (tag) => {
  if (!tag) return false;
  let subcat = tag.settings && tag.settings.subcategory && tag.settings.subcategory[0];
  let subtype = subcat && subcat.type;
  return subtype === 105;
}

export const getEngagements = (tag) => {
  if (tag && tag.settings && tag.settings.subcategory) {
    return [].concat.apply(
      [],
      tag.settings.subcategory.map(item => item.engagements)
    );
  }
  return [];
};

export const validHex = (val) => /^#(?:[0-9a-fA-F]{3}){1,2}$/.test(val);

export function validateEmail(email) {
  var sQtext = '[^\\x0d\\x22\\x5c\\x80-\\xff]';
  var sDtext = '[^\\x0d\\x5b-\\x5d\\x80-\\xff]';
  var sAtom = '[^\\x00-\\x20\\x22\\x28\\x29\\x2c\\x2e\\x3a-\\x3c\\x3e\\x40\\x5b-\\x5d\\x7f-\\xff]+';
  var sQuotedPair = '\\x5c[\\x00-\\x7f]';
  var sDomainLiteral = '\\x5b(' + sDtext + '|' + sQuotedPair + ')*\\x5d';
  var sQuotedString = '\\x22(' + sQtext + '|' + sQuotedPair + ')*\\x22';
  var sDomain_ref = sAtom;
  var sSubDomain = '(' + sDomain_ref + '|' + sDomainLiteral + ')';
  var sWord = '(' + sAtom + '|' + sQuotedString + ')';
  var sDomain = sSubDomain + '(\\x2e' + sSubDomain + ')+';
  var sLocalPart = sWord + '(\\x2e' + sWord + ')*';
  var sAddrSpec = sLocalPart + '\\x40' + sDomain; // complete RFC822 email address spec
  var sValidEmail = '^' + sAddrSpec + '$'; // as whole string

  var reValidEmail = new RegExp(sValidEmail);

  return reValidEmail.test(email);
}

export function validatePhoneNumber(num) {
  num = num.replace('+', '');
  num = num.replace('(', '');
  num = num.replace(')', '');
  num = num.replace(' ', '');
  const isValid = /^\d+$/.test(num) && num.length >=8;
  return isValid;
}

export function addPixelImage(src) {
  const img = document.createElement('img');
  img.width = 1;
  img.height = 1;
  img.style = 'border-style:none;display:none;';
  img.alt = '';
  img.src = src;
  document.body.appendChild(img);
}

const roundToX = (num = 0, X = 20) => +(Math.round(num + `e${X}`) + `e-${X}`);
export { roundToX };

export function handleExternalLinksViaClickThru(url, creativeData) {
  const cltScript = creativeData && creativeData.prod && creativeData.prod.cltScript;
  if (cltScript) {
    appendThirdPartyScriptToDOM(cltScript);
  }
  const network = creativeData && creativeData.network;
  const clickThru = network && constants.CLICKTHRU_NETWORKS.includes(network);
  if (!clickThru) {
    window.open(url, '_blank');
  } else {
    if (window.vpaid) {
      window.vpaid.clickThru({
        url,
        playerHandles: true, // forces to use the adunit url
      });
      window.vpaid.pauseAd();
    }
  }
}

export function appendThirdPartyScriptToDOM(str) {
  const BODY = document.getElementsByTagName('body')[0];
  if (str) {
    const node = document.createRange().createContextualFragment(str);
    BODY.append(node);
  }
}

export function addCustomCssNode(styleStr) {
  const HEAD = document.getElementsByTagName('head')[0];
  const st = document.createElement("style");
  st.appendChild(document.createTextNode(styleStr));
  HEAD.appendChild(st);
}

export function fetchPersonalizeJson() {
  return fetch('https://cdn.wootag.com/generic/json/personalize-layer.json')
    .then(res => res.json())
    .catch(err => {
      console.error('Error fetching personalize.json', err);
    });
}


// WEBPACK FOOTER //
// ./components/helper.js